<template>
  <div class="mapBox">
    <GmapMap :center="marker.position" :zoom="15" ref="mapRef" class="map-main">
      <GmapMarker
        :position="marker.position"
        :clickable="true"
        :icon="marker.markerData"
        @click="marker.position"
        class="map-marker"
        :label="marker.label"
      ></GmapMarker>
      <!-- <infoWindow :position="marker.position" :opened="true" :content="content" :infoWindow="infoWindow">
      </infoWindow> -->
    </GmapMap>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content: "<div>fsafsaff fsafsa fsddsad  fsafsafas</div>",
      marker: {
        markerData: {
          url: require("@/assets/logo.png"),
          size: { width: 33, height: 22, f: "px", b: "px" },
          scaledSize: { width: 33, height: 22, f: "px", b: "px" },
          labelOrigin: { x: 16, y: -10 },
        },
        label: "East Coast Mall",
        position: {
          lat: 22.3193039,
          lng: 114.1693611,
        },
      },
      center:{}
    };
  },
  methods:{
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        // console.log(position.coords)
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
  },
  created(){
    this.geolocate()
  }
};
</script>

<style>
.map-main {
  width: 100%;
  height: 500px;
  border-radius: 10px;
  overflow: hidden;
}
</style>